import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {

    const exportToPDF = (contactDetails) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [25, 25, 25, 25],
            content: getContent(contactDetails),

            styles: {
                nameTitle: {
                    fontSize: 28,
                    bold: true,
                    color: '#000000',
                    margin: [0, 0, 0, 5]
                },
                designation: {
                    fontSize: 14,
                    color: '#000000',
                    margin: [0, 0, 0, 8]
                },
                contactInfo: {
                    fontSize: 10,
                    color: '#000',
                    margin: [0, 2, 0, 2]
                },

                sectionTitle: {
                    fontSize: 14,
                    bold: true,
                    color: '#000000',
                    margin: [0, 10, 0, 10],
                    decoration: 'underline',
                    decorationStyle: 'solid',
                    decorationColor: '#000000'
                },

                cardSection: {
                    fillColor: '#f8f9fa',
                    margin: [0, 5, 0, 15]
                },

                tableHeader: {
                    fontSize: 10,
                    bold: true,
                    color: '#000000',
                    fillColor: '#ecf0f1',
                    margin: [2,2,2,2]
                },

                tableContent: {
                    fontSize: 10,
                    color: '#000'
                },

                infoLabel: {
                    fontSize: 10,
                    bold: true,
                    color: '#000'
                },
                infoValue: {
                    fontSize: 10,
                    color: '#000'
                },

                skillItem: {
                    fontSize: 10,
                    margin: [0, 3, 0, 3],
                    color: '#000000'
                },

                companyName: {
                    fontSize: 10,
                    bold: true,
                    color: '#000000'
                },
                jobTitle: {
                    fontSize: 9,
                    color: '#000000',
                    italics: true
                },
                duration: {
                    fontSize: 10,
                    color: '#000'
                }
            },

            defaultStyle: {
                color: '#000',
                fontSize: 10,
                font: 'SulaimanLipi',
                lineHeight: 1.3
            },

            info: {
                title: "Employee Profile - Modern Design",
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    function capitalizeWords(str) {
        return str
            ? str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())
            : '';
    }

    function infoColumnRow(label, value) {
        return value
            ? {
                columns: [
                    { width: '40%', text: label, style: 'infoLabel' },
                    { width: '60%', text: value, style: 'infoValue' }
                ],
                margin: [0, 2, 0, 2]
            }
            : null;
    }

    const getContent = (contactDetails) => {
        return [
            {
                columns: [
                    {
                        width: '65%',
                        stack: [
                            {text: capitalizeWords(contactDetails.full_name), style: 'nameTitle'},
                            {
                                canvas: [
                                    {
                                        type: 'line',
                                        x1: 0, y1: 0, x2: 200, y2: 0,
                                        lineWidth: 1,
                                        lineColor: '#000000'
                                    }
                                ],
                            },

                            contactDetails.phone
                                ? {text: contactDetails.phone, style: 'contactInfo'}
                                : '',

                            contactDetails.email
                                ? {text: contactDetails.email, style: 'contactInfo'}
                                : '',
                        ]
                    },
                    {
                        width: '35%',
                        stack: [
                            {
                                image: contactDetails.photo64,
                                alignment: 'center',
                                maxHeight: 80,
                                border: [true, true, true, true],
                                fillColor: '#ecf0f1'
                            }
                        ]
                    }
                ]
            },

            {text: 'Personal Information', style: 'sectionTitle'},
            {
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                stack: [
                                    {
                                        text: 'Basic Details',
                                        fontSize: 12,
                                        bold: true,
                                        color: '#000',
                                        margin: [0, 0, 0, 8]
                                    },

                                    infoColumnRow('Father Name:', contactDetails.father_name),
                                    infoColumnRow('Mother Name:', contactDetails.mother_name),
                                    infoColumnRow('Date of Birth:', contactDetails.birthday),
                                    infoColumnRow('Gender:', contactDetails.gender),
                                    infoColumnRow('Religion:', contactDetails.religion),
                                    infoColumnRow('Blood Group:', contactDetails.blood_group),
                                ],
                                margin: 10
                            },
                            {
                                stack: [
                                    {
                                        text: 'Additional Info',
                                        fontSize: 12,
                                        bold: true,
                                        color: '#000',
                                        margin: [0, 0, 0, 8]
                                    },

                                    infoColumnRow('Marital Status:', contactDetails.marital_status),
                                    infoColumnRow('Nationality:', contactDetails.country),
                                    infoColumnRow('Passport/NID:', contactDetails.nid),
                                    infoColumnRow('TIN NO:', contactDetails.tin_no),
                                    infoColumnRow('Address:', contactDetails.full_address)
                                ],
                                margin: 10
                            }
                        ]
                    ]
                },
                layout: 'noBorders'
            },

            { text: 'Current Employment Info', style: 'sectionTitle', margin: [0, 10, 0, 10] },
            {
                columns: [
                    {
                        width: '100%',
                        table: {
                            headerRows: 1,
                            widths: ['40%', '60%'],
                            body: [
                                [
                                    { text: 'Branch', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_branch_name || '', fontSize: 8 }
                                ],
                                [
                                    { text: 'Division', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_division_name || '', fontSize: 8 }
                                ],
                                [
                                    { text: 'Department', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_department_name || '', fontSize: 8 }
                                ],
                                [
                                    { text: 'Designation', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_designation_name || '', fontSize: 8 }
                                ],
                                [
                                    { text: 'Business Unit', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_business_unit_name || '', fontSize: 8 }
                                ],
                                [
                                    { text: 'Employment Category', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_employee_category_name || '', fontSize: 8 }
                                ],
                                [
                                    { text: 'Job Status', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_job_status_name || '', fontSize: 8 }
                                ],
                                [
                                    { text: 'Joining Date', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_date_of_joining || '', fontSize: 8 }
                                ],
                                [
                                    { text: 'Effective Date', bold: true, fontSize: 8 },
                                    { text: contactDetails.employment_effective_date || '', fontSize: 8 }
                                ]
                            ]
                        },
                        layout: {
                            hLineColor: () => '#000000',
                            vLineColor: () => '#000000',
                            hLineWidth: () => 0.3,
                            vLineWidth: () => 0.3,
                            paddingLeft: () => 2,
                            paddingRight: () => 2,
                            paddingTop: () => 2,
                            paddingBottom: () => 2,
                        }
                    }
                ]
            },

            (contactDetails.employment_logs && contactDetails.employment_logs.length > 0) ?
                [
                    { text: 'Previous Employment Info', style: 'sectionTitle', margin: [0, 10, 0, 10] },
                    {
                        columns: [
                            {
                                width: '100%',
                                stack: [
                                    {
                                        table: {
                                            headerRows: 1,
                                            widths: ['15%', '17%', '17%', '17%', '17%', '17%'],
                                            body: prevEmploymentHistory(contactDetails)
                                        },
                                        layout: {
                                            hLineWidth: () => 0.3,
                                            vLineWidth: () => 0.3,
                                            paddingLeft: () => 1,
                                            paddingRight: () => 1,
                                            paddingTop: () => 1,
                                            paddingBottom: () => 1,
                                        }
                                    }
                                ]
                            }
                        ]
                    }
            ] : [],

            (contactDetails.organization_items && contactDetails.organization_items.length > 0) ?
                [
                    { text: 'Professional Experience', style: 'sectionTitle' },
                    {
                        table: {
                            widths: ['40%', '30%', '15%', '15%'],
                            body: professionalExperience(contactDetails),
                            margin: [0, 0, 0, 0]
                        },
                        layout: {
                            hLineWidth: () => 0.5,
                            vLineWidth: () => 0.5,
                            hLineColor: () => '#000000',
                            vLineColor: () => '#000000',
                        },
                        margin: [0, 0, 0, 8]
                    }
                ]
                : [],

            (contactDetails.education_items && contactDetails.education_items.length > 0) ?
             [
                {text: 'Academic Qualifications', style: 'sectionTitle'},
                {
                    table: {
                        headerRows: 1,
                        widths: ['25%', '15%', '15%', '15%', '15%', '15%'],
                        body:  educationHistory(contactDetails)
                    },
                    layout: {
                        fillColor: (rowIndex) => {
                            return rowIndex === 0 ? '#3498db' : (rowIndex % 2 === 0 ? '#f8f9fa' : '#ffffff');
                        },
                        hLineWidth: () => 0.3,
                        vLineWidth: () => 0.3,
                        paddingLeft: () => 2,
                        paddingRight: () => 2,
                        paddingTop: () => 2,
                        paddingBottom: () => 2,
                    }
                }
            ]: [],

            {
                columns: [
                  (contactDetails.skills_expertise && contactDetails.skills_expertise.length > 0)
                    ?
                    {
                        width: '48%',
                        stack: [
                            {text: 'Skills & Expertise', style: 'sectionTitle'},
                            {
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [{
                                            stack: skillAndExpertise(contactDetails),
                                            margin: [0,0,0,0]
                                        }]
                                    ]
                                },
                                layout: {
                                    hLineWidth: function (i, node) {
                                        return 0.5;
                                    },
                                    vLineWidth: function (i, node) {
                                        return 0.5;
                                    },
                                    hLineColor: function (i, node) {
                                        return '#000000';
                                    },
                                    vLineColor: function (i, node) {
                                        return '#000000';
                                    }
                                }
                            }
                        ]
                    }  : { text: '', width: '48%' },
                    {
                        width: '4%',
                        text: ''
                    },
                    ((contactDetails.supervisor_items && contactDetails.supervisor_items.length > 0) || (contactDetails.leave_approver_items && contactDetails.leave_approver_items.length > 0))
                        ? {
                            width: '48%',
                            stack: [
                                { text: 'Other Details', style: 'sectionTitle' },
                                {
                                    table: {
                                        widths: ['44%', '54%'],
                                        body: supervisorData(contactDetails)
                                    },
                                    layout: {
                                        hLineWidth: () => 0.3,
                                        vLineWidth: () => 0.3,
                                        paddingLeft: () => 2,
                                        paddingRight: () => 2,
                                        paddingTop: () => 2,
                                        paddingBottom: () => 2,
                                    }
                                }
                            ]
                        }
                        : { text: '', width: '48%' }

                ]
            },

            {
                columns: [
                    (contactDetails.skills_expertise && contactDetails.skills_expertise.length > 0) ?
                        {
                            width: '48%',
                            stack: [
                                {text: 'Salary Structure', style: 'sectionTitle'},
                                {
                                    table: {
                                        widths: ['60%', '40%'],
                                        body: salaryStructureData(contactDetails)
                                    },
                                    layout: {
                                        hLineWidth: () => 0.3,
                                        vLineWidth: () => 0.3,
                                        paddingLeft: () => 2,
                                        paddingRight: () => 2,
                                        paddingTop: () => 2,
                                        paddingBottom: () => 2,
                                    }
                                }
                            ]
                        }  : { text: '', width: '48%' },
                        {
                            width: '4%',
                            text: ''
                        },
                        {
                            width: '48%',
                            stack: [
                                {text: 'Payment Details', style: 'sectionTitle'},
                                {
                                    table: {
                                        widths: ['50%', '50%'],
                                        body: [
                                            [
                                                {text: 'Account Name', style: 'infoLabel', bold: true},
                                                {text: contactDetails.payment_account_name || '', style: 'infoValue'}
                                            ],
                                            [
                                                {text: 'Account No.', style: 'infoLabel', bold: true},
                                                {text: contactDetails.account_no || '', style: 'infoValue'}
                                            ],
                                            [
                                                {text: 'Bank Name', style: 'infoLabel', bold: true},
                                                {text: contactDetails.bank_name || '', style: 'infoValue'}
                                            ],
                                            [
                                                {text: 'Branch Name', style: 'infoLabel', bold: true},
                                                {text: contactDetails.branch_name || '', style: 'infoValue'}
                                            ],
                                            [
                                                {text: 'Routing No.', style: 'infoLabel', bold: true},
                                                {text: contactDetails.routing_no || '', style: 'infoValue'}
                                            ],
                                            [
                                                {text: 'Term', style: 'infoLabel', bold: true},
                                                {text: contactDetails.credit_term || '', style: 'infoValue'}
                                            ],
                                        ]
                                    },
                                    layout: {
                                        hLineWidth: () => 0.3,
                                        vLineWidth: () => 0.3,
                                        paddingLeft: () => 2,
                                        paddingRight: () => 2,
                                        paddingTop: () => 2,
                                        paddingBottom: () => 2,
                                    }
                                }
                            ]
                        }
                    ]
            },
        ];
    };

    function prevEmploymentHistory(contactDetails) {
        let prevEmploymentBody = [
            [
                {text: 'Effective Date', style: 'tableHeader'},
                {text: 'Branch', style: 'tableHeader'},
                {text: 'Division', style: 'tableHeader'},
                {text: 'Department', style: 'tableHeader'},
                {text: 'Business Unit', style: 'tableHeader'},
                {text: 'Remarks', style: 'tableHeader'}
            ]
        ];

        if (contactDetails.employment_logs && contactDetails.employment_logs.length > 0) {
            contactDetails.employment_logs.forEach(prev => {
                prevEmploymentBody.push([
                    {text: prev.employment_effective_date || '', style: 'tableContent', fontSize: 8},
                    {text: prev.employment_branch_name || '', style: 'tableContent', fontSize: 8},
                    {text: prev.employment_division_name || '', style: 'tableContent', fontSize: 8},
                    {text: prev.employment_department_name || '', style: 'tableContent', fontSize: 8},
                    {text: prev.employment_business_unit_name || '', style: 'tableContent', fontSize: 8},
                    {text: prev.employment_remarks || '', style: 'tableContent', fontSize: 8}
                ]);
            });
        }

        return prevEmploymentBody;
    }

    function professionalExperience(contactDetails) {
        let dataRow = [
            [
                {text: 'Organization Name', style: 'tableHeader'},
                {text: 'Location', style: 'tableHeader'},
                {text: 'Start Date', style: 'tableHeader'},
                {text: 'End Date', style: 'tableHeader'},
            ]
        ];
        if (contactDetails.organization_items && contactDetails.organization_items.length > 0) {
            contactDetails.organization_items.forEach(prev => {
                dataRow.push([
                    { text: prev.organization || '', style: 'tableContent', fontSize: 8 },
                    { text: prev.location || '', style: 'tableContent', fontSize: 8 },
                    { text: prev.start_date || '', style: 'tableContent', fontSize: 8 },
                    { text: prev.end_date ? prev.end_date : 'Current', style: 'tableContent', fontSize: 8 },
                ]);
            });
        }

        return dataRow;
    }

    function educationHistory(contactDetails) {
        let dataRow = [
            [
                {text: 'Institution', style: 'tableHeader'},
                {text: 'Degree', style: 'tableHeader'},
                {text: 'Duration', style: 'tableHeader'},
                {text: 'Passing Year', style: 'tableHeader'},
                {text: 'Start', style: 'tableHeader'},
                {text: 'End', style: 'tableHeader'}
            ],
        ];
        if (contactDetails.education_items && contactDetails.education_items.length > 0) {
            contactDetails.education_items.forEach(item => {
                dataRow.push([
                    { text: item.education || '', style: 'tableContent', fontSize: 8 },
                    { text: item.degree || '', style: 'tableContent', fontSize: 8 },
                    { text: item.duration || '', style: 'tableContent', fontSize: 8 },
                    { text: item.passing_year || '', style: 'tableContent', fontSize: 8 },
                    { text: item.start_date || '', style: 'tableContent', fontSize: 8 },
                    { text: item.end_date || '', style: 'tableContent', fontSize: 8 }
                ]);
            });
        }

        return dataRow;
    }

    function skillAndExpertise(contactDetails) {
        let skillsStack = [];
        if (contactDetails.skills_expertise && contactDetails.skills_expertise.length > 0) {
            contactDetails.skills_expertise.forEach(item => {
                skillsStack.push({
                    text: [
                        {text: item.skills_expertise, bold: true},
                        {text: `: ${item.details}`, bold: false, fontSize: 10}
                    ],
                    style: 'skillItem'
                });
            });
        }

        return skillsStack;
    }

    function supervisorData(contactDetails) {
        let stackList = [];
        if (contactDetails.supervisor_items && contactDetails.supervisor_items.length > 0) {
            contactDetails.supervisor_items.forEach(item => {
                stackList.push([
                    {text: 'Supervisor', style: 'infoLabel', bold: true},
                    {text: item.supervisor_name || '', style: 'infoValue'}
                ]);
            });
        }

        if (contactDetails.leave_approver_items && contactDetails.leave_approver_items.length > 0) {
            contactDetails.leave_approver_items.forEach(item => {
                stackList.push([
                    {text: 'Leave Approver', style: 'infoLabel', bold: true},
                    {text: item.leave_approver_name || '', style: 'infoValue'}
                ]);
            });
        }

        return stackList;
    }

    function salaryStructureData(contactDetails) {
        let dataRow = [
            [
                { text: 'Pay Head', style: 'tableHeader' },
                { text: 'Amount', style: 'tableHeader' },
            ],
        ];

        if (!contactDetails.salary_structures || contactDetails.salary_structures.length === 0) {
            return dataRow;
        }

        const first = contactDetails.salary_structures[0];

        first.salary_type_name && dataRow.push([
            { text: 'Salary Type', style: 'tableContent', fontSize: 8, alignment: 'left' },
            { text: first.salary_type_name, style: 'tableContent', fontSize: 8, alignment: 'right' },
        ]);

        (first.scale_amount && first.grade_number) && dataRow.push([
            { text: 'Salary Grade Scale', style: 'tableContent', fontSize: 8, alignment: 'left' },
            { text: `${first.grade_number} (${first.scale_amount})`, style: 'tableContent', fontSize: 8, alignment: 'right' },
        ]);
 
        contactDetails.salary_structures.forEach(item => {
            dataRow.push([
                { text: item.pay_head_name || '', style: 'tableContent', fontSize: 8, alignment: 'left' },
                { text: item.pay_head_amount || '', style: 'tableContent', fontSize: 8, alignment: 'right' },
            ]);
        });

        return dataRow;
    }


    return {
        exportToPDF
    }
};

export default pdfPrinter;